const otAssetGateway = {
    fetchOTAsset: async (token: string) => {
      // const url = `/check_token/${token}`;
      try {
        // const res = await axiosClient.get(url);
        const res = [
          { id: 1, ip: '192.0.2.1', macAddress: '00:1B:44:11:3A:B7', landscape: 3,displayName:"Router"},
          { id: 2, ip: '192.0.2.2', macAddress: '00:1B:44:11:3A:B7', landscape: 1,displayName:"Modbus Server" },
          { id: 3, ip: '192.0.2.3', macAddress: '00:1B:44:11:3A:B7', landscape: 4,displayName:"Opc"},
        ];
        return {
          status: 'success',
          res,
        };
      } catch (error) {
        return {
          status: 'error',
          error,
        };
      }
    }
}

export default otAssetGateway;